<!--  -->
<template>
  <!-- ! v-if="mobile" -->
  <v-bottom-navigation
    class="bottomNavHeight"
    style="z-index: 10000"
    :model-value="true"
    color="white"
  >
    <OnexButton
      variant="text"
      :value="RouteNames.DASHBOARD"
      @click="nav.goToMyFinancialHome"
      class="specificHeightButton"
      tabindex="0"
    >
      <div :class="nav.isRouteDashboard() ? 'selectedBottomIcon' : 'notSelectedBottomIcon'">
        <div><v-icon size="30" :icon="getHomeIcon" /></div>
        <div>{{ $t('L_home') }}</div>
      </div>
    </OnexButton>

    <OnexButton
      variant="text"
      :value="RouteNames.TERM_LIFE_BENEFITS"
      @click="nav.termLifeAction"
      class="specificHeightButton"
      tabindex="0"
    >
      <div :class="nav.isRouteTermLifeBenefits() ? 'selectedBottomIcon' : 'notSelectedBottomIcon'">
        <div><v-icon size="30" :icon="getLifeIcon" /></div>
        <div>{{ $t('L_life') }}</div>
      </div>
    </OnexButton>
    <OnexButton
      variant="text"
      :value="RouteNames.INVESTMENTS"
      @click="nav.investmentsAction()"
      class="specificHeightButton"
      tabindex="0"
    >
      <div :class="nav.isRouteInvestments() ? 'selectedBottomIcon' : 'notSelectedBottomIcon'">
        <div><v-icon size="30" :icon="getInvestmentIcon" /></div>
        <div>{{ $t('L_invest') }}</div>
      </div>
    </OnexButton>
    <OnexButton
      variant="text"
      :value="RouteNames.DEBT_SOLUTIONS"
      @click.prevent="nav.debtAction"
      class="specificHeightButton"
      tabindex="0"
    >
      <div :class="nav.isRouteDebtSolutions() ? 'selectedBottomIcon' : 'notSelectedBottomIcon'">
        <div><v-icon size="30" :icon="getDebtIcon" /></div>
        <div>{{ $t('L_debt_text') }}</div>
      </div>
    </OnexButton>
    <!-- ! v-model="bottomNavigationMoreMenu" -->
    <!-- ! activator="#bottom-nav-more-button" -->
    <v-menu
      style="z-index: 10002"
      transition="slide-y-transition"
      :close-on-content-click="true"
      class="ml-2"
    >
      <template #activator="{ props }">
        <OnexButton
          v-bind="props"
          id="bottomNavMoreButton"
          :color="'#FFFFFF'"
          variant="text"
          value="more"
          @click="bottomNavigationMoreMenu = !bottomNavigationMoreMenu"
          class="specificHeightButton"
          tabindex="0"
        >
          <div :class="isMoreNavButtonSelected ? 'selectedBottomIcon' : 'notSelectedBottomIcon'">
            <div><v-icon size="30" :icon="mdiDotsHorizontal" /></div>
            <div>{{ $t('L_more') }}</div>
          </div>
        </OnexButton>
      </template>
      <v-list ref="items">
        <v-list-item
          v-if="showRepLink"
          @click.prevent="
            nav.repAction();
            bottomNavigationMoreMenu = false;
          "
          :class="[nav.isRouteMyRep() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass']"
        >
          <v-list-item-title class="font-size--16">
            {{ $t('L_my_rep') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          @click.prevent="
            nav.documentsAction($vuetify.display.xs);
            bottomNavigationMoreMenu = false;
          "
          :class="[nav.isRouteDocuments() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass']"
        >
          <v-list-item-title class="font-size--16">
            {{ $t('L_my_document') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          @click.prevent="
            helpAction($vuetify.display.xs);
            bottomNavigationMoreMenu = false;
          "
          :class="[nav.isRouteHelp() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass']"
        >
          <v-list-item-title class="font-size--16">
            {{ $t('L_help') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          :class="[nav.isRouteMyAccount() ? 'selectedMenuItemClass' : 'nonSelectedMenuItemClass']"
        >
          <v-list-item-title
            class="font-size--16"
            @click.prevent="
              nav.accountAction();
              bottomNavigationMoreMenu = false;
            "
          >
            {{ $t('L_account_setting') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          @click="
            logout();
            bottomNavigationMoreMenu = false;
          "
          class="signOutClass"
        >
          <v-list-item-title class="font-size--16 signOutInnerClass">
            {{ $t('L_sign_out') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-bottom-navigation>
</template>

<script lang="ts">
import { getNav } from '@/shared/navLogic';
import { RouteNames } from '@/router/routeNames';
import { UILocale } from '@/shared';
import { LOCALES, COUNTRIES } from '@/shared/models/constants.models';
import { useGlobalStore } from '@/stores/global/global.store';
import {
  mdiChartBox,
  mdiChartBoxOutline,
  mdiCreditCardOff,
  mdiCreditCardOffOutline,
  mdiDotsHorizontal,
  mdiHome,
  mdiHomeOutline,
  mdiShieldAccount,
  mdiShieldAccountOutline,
  mdiWeb,
} from '@mdi/js';
import { mapStores, mapState } from 'pinia';
import { OnexButton } from '@primerica/onex-ui-lib';
import { type ComponentOptions, defineComponent } from 'vue';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { openInNewWindow } from '@/mixins/openNewWindow';

const componentOptions: ComponentOptions = {
  name: 'BottomNavigationForMobile',
  components: {
    OnexButton,
  },
  mixins: [openInNewWindow],
  data() {
    return {
      bottomNavigationMoreMenu: false,
      RouteNames,
      mdiHome,
      mdiHomeOutline,
      mdiShieldAccount,
      mdiShieldAccountOutline,
      mdiChartBox,
      mdiChartBoxOutline,
      mdiCreditCardOff,
      mdiCreditCardOffOutline,
      mdiDotsHorizontal,
      mdiWeb,
      nav: getNav(),
    };
  },
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    ...mapStores(useGlobalStore),
    getHomeIcon() {
      if (this.nav.isRouteDashboard()) {
        return mdiHome;
      } else {
        return mdiHomeOutline;
      }
    },
    getLifeIcon() {
      if (this.nav.isRouteTermLifeBenefits()) {
        return mdiShieldAccount;
      } else {
        return mdiShieldAccountOutline;
      }
    },
    getInvestmentIcon() {
      if (this.nav.isRouteInvestments()) {
        return mdiChartBox;
      } else {
        return mdiChartBoxOutline;
      }
    },
    getDebtIcon() {
      if (this.nav.isRouteDebtSolutions()) {
        return mdiCreditCardOff;
      } else {
        return mdiCreditCardOffOutline;
      }
    },
    isCanadian() {
      return this.customerProfile?.country === COUNTRIES.CANADA;
    },
    isMoreNavButtonSelected() {
      if (this.bottomNavigationMoreMenu !== false) {
        return true;
      }
      return false;
    },
    showRepLink() {
      return this.globalStore.agents?.length > 0;
    },
  },
  methods: {
    async helpAction() {
      const globalStore = useGlobalStore();
      if (globalStore.containsFeature('HELP')) {
        const newRightAnswersUrl =
          this.locale === 'fr_CA'
            ? window.appConfig.endpoints.frRightanswerslinkpostjune2025
            : window.appConfig.endpoints.rightanswerslinkpostjune2025;
        const isWeb = CapacitorFacade.isWeb();
        await this.openInNewWindow({
          url: newRightAnswersUrl,
          inappbrowser: !isWeb,
          target: 'RADashboardWinName',
        });
      }
    },
    logout() {
      this.$emit('logout');
    },
    updateLocale(language: LOCALES) {
      this.globalStore.updateLocale(language);
      switch (language) {
        case LOCALES.en_US:
          this.$i18n.locale = UILocale.EN_US;
          break;
        case LOCALES.es_US:
          this.$i18n.locale = UILocale.ES_US;
          break;
        case LOCALES.en_CA:
          this.$i18n.locale = UILocale.EN_CA;
          break;
        case LOCALES.fr_CA:
          this.$i18n.locale = UILocale.FR_CA;
          break;
        default:
          break;
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.v-bottom-navigation.bottomNavHeight {
  background-color: rgb(var(--v-theme-grey100));
  height: 115px !important;
  width: 100%;
  padding-bottom: 28px;
}
.v-bottom-navigation.bottomNavHeight > .v-bottom-navigation__content {
  align-items: center;
  gap: 8px;
}
.bottomNavHeight > .v-bottom-navigation__content > .v-btn--selected,
.selectedBottomIcon {
  background-color: rgb(var(--v-theme-blueGrey300)) !important;
  color: rgb(var(--v-theme-blue600)) !important;
  width: 65px;
  min-width: 65px;
  padding: 0px !important;
  margin: 0px !important;
}
.v-bottom-navigation.bottomNavHeight > .v-bottom-navigation__content > .v-btn:not(.v-btn--selected),
.notSelectedBottomIcon {
  color: rgb(var(--v-theme-grey800)) !important;
  width: 65px;
  min-width: 65px;
  padding: 0px !important;
  margin: 0px !important;
}
.v-bottom-navigation.bottomNavHeight > .v-bottom-navigation__content > .v-btn.specificHeightButton {
  height: auto;
  padding: 0 !important;
}
</style>
